<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>低温商品截止时间管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item>
          星期：
          <el-select v-model="ruleForm.dwReserveWeek" placeholder="请选择星期">
            <el-option v-for="item in weeklist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-time-select
            v-model="ruleForm.dwReserveHour"
            :picker-options="{
              start: '06:00',
              step: '01:00',
              end: '24:00',
            }"
            placeholder="选择几点截止"
            style="margin-left: 20px"
          >
          </el-time-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="ruleForm.update_seasion" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>

      <el-button type="primary" plain @click="sureClick">确认修改</el-button>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      weeklist: [
        { name: '一', id: 1 },
        { name: '二', id: 2 },
        { name: '三', id: 3 },
        { name: '四', id: 4 },
        { name: '五', id: 5 },
        { name: '六', id: 6 },
        { name: '日', id: 7 },
      ],

      ruleForm: {
        dwReserveWeek: null,
        dwReserveHour: null,
        update_seasion: null,
      },

      rules: {
        dwReserveWeek: [
          { required: true, message: '请选择截止为周几', trigger: 'blur' }
        ],
        dwReserveHour: [
          { required: true, message: '请选择截止为时间', trigger: 'blur' }
        ]
      },
    }
  },

  created () {
    this.getEndTimeData();
  },

  methods: {

    // 编辑
    editOrder (id) {
      console.log(id);
      // this.$router.push({ path: '/order/detail', query: { id: id } })
    },

    //修改订单信息
    sureClick () {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/good/changeDwGoodEndTimeData', this.ruleForm)
        if (res.code !== 200) {
          return this.$message.error('修改信息失败！')
        }
        this.$message.success('修改信息成功！')
        // this.getDetail();
        this.$router.push('/goods')
      })
    },


    async getEndTimeData () {
      const { data: res } = await this.$http.get('admin/good/getDwGoodEndTimeData')
      if (res.code !== 200) {
        return this.$message.error('获取信息失败！')
      }
      console.log(res)
      this.ruleForm = res.result
    },




  }
}
</script>

<style lang="less" scoped>
.el-button {
  margin-top: 30px;
}
</style>
